import { rootPath } from '@js/utils/url';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { indexName } from './config';

const getUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(params);
};

const hasSearchQuery = (query) => {
  return query && query.length > 0;
};

const router = historyRouter({
  windowTitle({ query }) {
    if (!hasSearchQuery(query)) {
      return window.baseTitle;
    }

    const queryTitle = query ? `Results for "${query}"` : 'Search';
    return `${queryTitle} – Solaris Japan`;
  },

  createURL({ qsModule, routeState }) {
    const path = rootPath();

    const queryParameters = {};
    if (routeState.query) queryParameters.query = encodeURIComponent(routeState.query);
    if (routeState.category) queryParameters.category = encodeURIComponent(routeState.category);
    if (routeState.preOrder === 'true') queryParameters.preOrder = true;
    if (routeState.page && routeState.page > 1) queryParameters.page = routeState.page;
    if (routeState.aff) queryParameters.aff = routeState.aff;

    if (Object.keys(queryParameters).length === 0) {
      return `${path}search`;
    }

    const queryString = qsModule.stringify(queryParameters, {
      addQueryPrefix: true,
      arrayFormat: 'repeat',
    });

    return `${path}search/${queryString}`;
  },

  parseURL({ qsModule, location }) {
    const { aff, query = '', category = '', preOrder, page } = qsModule.parse(location.search.slice(1));

    return {
      aff,
      query: decodeURIComponent(query),
      category: decodeURIComponent(category),
      preOrder,
      page,
    };
  },
});

const stateMapping = {
  stateToRoute(uiState) {
    const indexUiState = uiState[indexName] || {};
    const { aff } = getUrlParams();

    return {
      aff,
      query: indexUiState.query,
      category: indexUiState.hierarchicalMenu?.['sub_categories.lvl0']?.[0],
      preOrder: indexUiState.refinementList?.is_preorder?.[0],
      page: indexUiState.page,
    };
  },

  routeToState(routeState) {
    const hierarchicalMenu = routeState.category ? { 'sub_categories.lvl0': [routeState.category] } : {};
    const refinementList = routeState.preOrder ? { is_preorder: [routeState.preOrder] } : {};

    return {
      [indexName]: {
        query: routeState.query,
        page: routeState.page,
        hierarchicalMenu,
        refinementList,
      },
    };
  },
};

const searchRouting = {
  router,
  stateMapping,
};

export default searchRouting;
